import Api from '../../api/Api'

const partnership = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    empty: '',
    testimoni: [],
    select_testimoni: [],
  },

  //mutations
  mutations: {
    SET_TESTIMONI(state, testimoni) {
      var temp = []
      testimoni.forEach((el) => {
        let data = {
          label: el.nama,
          value: el.id,
          photo: el.url_foto,
        }
        temp.push(data)
      })

      state.testimoni = testimoni
      state.select_testimoni = temp
    },
    SET_EMPTY(state, empty) {
      state.empty = empty
    },
  },

  //actions
  actions: {
    getKonten() {
      return new Promise((resolve, reject) => {
        Api.get(`/partnership/get_konten`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getKonten_landing() {
      return new Promise((resolve, reject) => {
        Api.get(`/partnership/get_konten/landing`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    get_mitra() {
      return new Promise((resolve, reject) => {
        Api.get(`/mitra`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    get_mitra_landing() {
      return new Promise((resolve, reject) => {
        Api.get(`/mitra/landing`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getDokumentasi() {
      return new Promise((resolve, reject) => {
        Api.get(`/dokumentasi`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getDokumentasiLanding() {
      return new Promise((resolve, reject) => {
        Api.get(`/dokumentasi/landing`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    get_testimoni_perusahaan({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get(`/testimoni_perusahaan`)
          .then((response) => {
            commit('SET_TESTIMONI', response.data.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    get_testimoni_perusahaan_landing() {
      return new Promise((resolve, reject) => {
        Api.get(`/testimoni_perusahaan/landing`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    get_detail_testimoni_perusahaan({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/testimoni_perusahaan/detail/${params.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getProduk() {
      return new Promise((resolve, reject) => {
        Api.get(`/produk`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getProdukLanding() {
      return new Promise((resolve, reject) => {
        Api.get(`/produk/landing`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubahLogo({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/partnership/logo`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubahLogoHeader({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/partnership/ubah_logohomepage`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_header_homepage({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/partnership/headerhomepage`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubahMitra({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/mitra/update/${params.id}`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubahDokumentasi({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/dokumentasi/detail/${params.id}`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    ubahHeaderTitle({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/partnership/headertitle`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    tambah_mitra({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/mitra`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    tambah_dokumentasi({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/dokumentasi`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    tambah_testimoni_perusahaan({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/testimoni_perusahaan`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    tambah_why({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/kenapa_dilatih`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    get_kenapa_dilatih_landing() {
      return new Promise((resolve, reject) => {
        Api.get(`/kenapa_dilatih/landing`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    tambah_produk({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/produk`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapus_testimoni_perusahaan({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/testimoni_perusahaan/delete/${params.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapus_mitra({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/mitra/delete/${params.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapus_dokumentasi({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/dokumentasi/delete/${params.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapus_why({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/kenapa_dilatih/delete/${params.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteProduk({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/produk/delete/${params.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detailProduk({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/produk/detail/${params.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    edit_why({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(`/kenapa_dilatih/detail/${params.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_testimoni_perusahaan({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/testimoni_perusahaan/update/${params.id}`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    activated_testimoni_perusahaan({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/testimoni_perusahaan/active`, params)
          .then((response) => {
            commit('')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_why({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/kenapa_dilatih/detail/${params.id}`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_produk({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post(`/produk/detail/${params.id}`, params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  getters: {
    getTestimoni(state) {
      return state.testimoni
    },
    getSelectTestimoni(state) {
      return state.select_testimoni
    },
  },
}

export default partnership
